import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { nextTick, onMounted } from "vue";
import {initializeComponents} from "@/core/plugins/keenthemes";
import {useGlobalStore} from "@/pinia/global";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const globalStore = useGlobalStore();

// const originalTitle = document.title;
// watch(() => userStore.user.alerts, () => {
//   if (userStore.user.alerts > 0) {
//     document.title = `(${userStore.user.alerts}) ${originalTitle}`;
//   } else {
//     document.title = originalTitle;
//   }
// })

let _titleState = 0;
// const toggleTitle = () => {
//   if (userStore.user.alerts > 0) {
//     if (titleState === 0) {
//       document.title = `(${userStore.user.alerts}) ${originalTitle}`;
//       titleState = 1;
//     } else {
//       document.title = `(${userStore.user.alerts < 10 ? '*' : '**'}) ${originalTitle}`;
//       titleState = 0;
//     }
//   } else {
//     document.title = originalTitle;
//   }
//   setTimeout(toggleTitle, 1000);
// }

onMounted(() => {
  /**
   * this is to override the layout config using saved data from localStorage
   * remove this to use config only from static config (@/core/config/DefaultLayoutConfig.ts)
   */
  // store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);

  nextTick(() => {
    initializeComponents();
    const muteNotification = localStorage.getItem('muteNotification');
    if (muteNotification) {
      globalStore.muteNotifications = muteNotification === 'true';
    }
  });
  // toggleTitle()
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})